import React from 'react';
import GpacGeneratorForm from '@gogpac/form-generator';
import { useResolvedTheme } from 'providers/ThemeModeProvider';

/**
 * `@gogpac/form-generator` bound to the app's painted theme mode. The library ships its own
 * MUI v5 theme, so it cannot read ours; it follows the `mode` prop instead. Light outside a
 * `ThemeModeProvider` or with the dark mode flag off.
 */
export const ThemedFormGenerator = props => {
  const { resolvedMode } = useResolvedTheme();
  return <GpacGeneratorForm {...props} mode={resolvedMode} />;
};

export default ThemedFormGenerator;
